import { pageConfig } from '@/common/service/page-config';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import { plansof } from '@/utils/chain';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getSelectedPlans', 'hasPendingRequest', 'planMapFlatRaw', 'boughtPlans']),
  },
  methods: {
    getDeltaPreCondition() {
      const oldPlanCode = pageConfig.oldPlanCode;
      if (this.hasPendingRequest[oldPlanCode]) return false; // pending plan
      const currentEditPlan = this.planMapFlatRaw.find((x) =>
        [oldPlanCode, PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(oldPlanCode)].includes(x.plan_code),
      );
      if (!currentEditPlan) return false; // not find current plan
      const editPlanType = currentEditPlan?.type;
      const boughtPlan = plansof(this.boughtPlans).type(editPlanType).get(0);
      if (!boughtPlan || boughtPlan?.isFreeTrial) return false; // is free trial plan or not bought current edit plan

      return true;
    },
  },
};
